import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { lastValueFrom } from 'rxjs';
import { FinzyService } from 'src/app/core/services/finzy.service';
import swal from 'sweetalert2';

interface UserProfessionTypes {
  type: string,
  icon: string,
  isSelected: boolean
}

enum ProfessionType {
  Salaried = 'Salaried',
  SelfEmployed = 'Self Employed',
}

@Component({
  selector: 'app-additional-info',
  templateUrl: './additional-info.component.html',
  styleUrl: './additional-info.component.scss'
})
export class AdditionalInfoComponent implements OnInit {

  kycForm!: FormGroup;

  public professionTypes: UserProfessionTypes[] = [
    {
      type: ProfessionType.Salaried,
      icon: '../../../../assets/images/salaried.png',
      isSelected: false
    },
    {
      type: ProfessionType.SelfEmployed,
      icon: '../../../../assets/images/selfemployed.png',
      isSelected: false
    }
  ];


  constructor(private fb: FormBuilder, private finzyService: FinzyService, private router: Router, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.spinner.hide();
    this.kycForm = this.fb.group({
      employeeType: ['', Validators.required],
      educationalQualification: ['', Validators.required]
    });
  }

  public selectedProfession: UserProfessionTypes | null = null;

  // onProfessionSelect(type: string) {
  //   this.selectedProfession = type;
  //   this.professionTypes.forEach(profession => profession.isSelected = false);
  //       profession.isSelected = true;
  //       this.selectedProfession = profession;
  //   this.kycForm.get('employeeType')?.setValue(type);
  //   this.kycForm.get('employeeType')?.markAsTouched();
  // }

  public onProfessionSelect(profession: UserProfessionTypes) {
    this.professionTypes.forEach(profession => profession.isSelected = false);
    profession.isSelected = true;
    this.selectedProfession = profession;
    this.kycForm.get('employeeType')?.setValue(profession.type);
    this.kycForm.get('employeeType')?.markAsTouched();
  }

  get m() {
    return this.kycForm.controls;
  }

  async onSubmit() {

    this.spinner.show();
    if (this.kycForm.valid) {
      const payload = {
        livelihood: {
          employeeType: this.kycForm.value.employeeType === 'Salaried' ? 'SALARIED' : 'SELF_EMPLOYED'
        },
        userInfo: {
          educationalQualification: this.kycForm.value.educationalQualification
        }
      };

      try {
        var res = await lastValueFrom(this.finzyService.Additonal_Deatils(payload));
        if (res['data'] != null) {
          this.spinner.hide();
          return this.router.navigateByUrl('/assist-journey/f/kyc');
        }
        else if (res['error'] === 'Rejected') {
          this.spinner.hide();
          return this.router.navigateByUrl('/assist-journey/sorry');
        }
        else {
          this.spinner.hide();
          swal.fire('Error', 'Something went wrong, please try again later');
        }
      }
      catch (err) {

        if (err.status === 0) {
          swal.fire('Error', 'Network Error: Please check your internet connection and try again.');
          return;
        }

        if (err?.status === 401) {
          this.spinner.hide();
          this.router.navigateByUrl('/assist-journey/session-expired');
        }

        swal.fire('Error', 'Something went wrong, please try again later');
      }
    }
    else {
      swal.fire('Error', 'Something went wrong, please try again later');
    }
    this.spinner.hide();
  }
}